<template>
    <div id="total" class="drop-shadow-sides">
        <table>
            <tr>
                <td class="label-column">Subtotal</td>
                <td class="value-column">{{ session.check.subTotal | toCurrency }}</td>
            </tr>
            <tr v-if="gratuities > 0">
                <td class="label-column">Gratuities</td>
                <td class="value-column">{{ gratuities | toCurrency }}</td>
            </tr>
            <tr>
                <td class="label-column">Tax Total</td>
                <td class="value-column">{{ taxTotal | toCurrency }}</td>
            </tr>
            <tr v-if="Math.abs(session.check.taxExempt) > 0">
                <td class="label-column bolder adjustment">Tax Exempt</td>
                <td class="value-column bolder adjustment">({{ Math.abs(session.check.taxExempt) | toCurrency }})</td>
            </tr>
            <tr>
                <td class="label-column bolder">Total</td>
                <td class="value-column bolder">{{ total | toCurrency }}</td>
            </tr>
            <tr v-if="isTipVisible">
                <td class="label-column bolder">Tip</td>
                <td class="value-column bolder">{{ tip | toCurrency }}</td>
            </tr>
        </table>
    </div>
</template>

<script>
    import { mapState, mapGetters } from "vuex";

    export default {
        name: "TotalDetail",
        props: {
            isTipVisible: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapState({
                session: state => state.session
            }),
            ...mapGetters([
                "total",
                "taxTotal",
                "tipTotal"
            ]),
            tip() {
                let tip;

                switch (this.$route.name) {
                    case "PaymentSummary": tip = this.tipTotal; break;
                    default: tip = this.session.tip;
                }

                return tip;
            },
            gratuities() {
                return this.session.check.gratuityTotal - this.session.check.gratuityTaxTotal;
            }
        }
    }
</script>

<style scoped>
    #total {
        background-color: var(--very-light-gray);
        padding: 10px;
        border-bottom: var(--border-gray) solid 1px;
    }

    .adjustment {
        color: var(--maroon-red);
    }
</style>